import { SettingsAccountScreen as SharedSettingsAccountScreen } from '@trinity/chat-components/components/Settings';
import { useAppSelector } from '@/store';

export const SettingsAccountScreen = () => {
  const user = useAppSelector((state) => ({
    firstName: state.user.profile.firstName,
    lastName: state.user.profile.lastName,
    email: state.user.email,
    photoUrl: state.user.profile.photoUrl,
  }));

  return <SharedSettingsAccountScreen user={user} />;
};
